import NumberUtils from "@/utils/NumberUtils";
import dayjs from "dayjs";
import {KenshinDto} from "@/dto/KenshinDto";
import PHantei from "@/enums/PHantei";
import TokushuKenshin from "@/enums/TokushuKenshin";
import ShisekiChinchakudo from "@/enums/ShisekiChinchakudo";
import SeisoJotai from "@/enums/SeisoJotai";

export default class KenshinService {
  private kenshinData: KenshinDto;
  private iroMap: Map<string, string>;
  private shishikiInfo: Map<string, Map<string, string>>;
  private teethInfo: Map<string, string>;
  private pHanteis: string[];
  private pHanteiColors: string[];
  private cpitns: string[];
  private cpitnColors: string[];
  constructor(iroMap: Map<string, string>, kenshinData: KenshinDto) {
    this.kenshinData = kenshinData
    const shishikiColors = kenshinData.shishikiIroKbn ?  kenshinData.shishikiIroKbn : ''
    const teethColors = kenshinData.haIroKbn ? kenshinData.haIroKbn : ''

    const pHantei = (kenshinData.pHantei ? kenshinData.pHantei : '      ').split('')
    const pHanteiIroKbn = (kenshinData.pHanteiIroKbn ? kenshinData.pHanteiIroKbn : ',,,,,').split(',')

    const cpitn = (kenshinData.cpitn ? kenshinData.cpitn : '      ').split('')
    const cpitnIroKbn = (kenshinData.cpitnIroKbn ? kenshinData.cpitnIroKbn : ',,,,,').split(',')

    this.iroMap = iroMap
    //歯式情報の初期化
    this.shishikiInfo = new Map<string, Map<string, string>>()
    const shishikiParts = shishikiColors.split(',')
    for(const row of shishikiParts){
      const arr = row.split('-')
      let eachParts = this.shishikiInfo.get(arr[0])
      if(!eachParts){
        eachParts = new Map<string, string>()
        this.shishikiInfo.set(arr[0], eachParts)
      }
      eachParts.set(arr[1], arr[2])
    }
    //歯情報の初期化
    const teethParts = teethColors.split(',')
    this.teethInfo = new Map<string, string>()
    for(const row of teethParts){
      const arr = row.split('-')
        this.teethInfo.set(arr[0], arr[1])
    }
    const obj = Object.fromEntries(
        Array.from(this.shishikiInfo, ([key, value]) => [key, Object.fromEntries(value)])
    );
    //P判定
    this.pHanteis = []
    this.pHanteiColors = []
    for(let i=0; i<pHantei.length; i++){
      this.pHanteis.push(PHantei.getName(pHantei[i] as string) as string)
      this.pHanteiColors.push((iroMap.get(pHanteiIroKbn[i]) ? iroMap.get(pHanteiIroKbn[i]) : 'transparent') as string)
    }
    //CPITN
    this.cpitns = []
    this.cpitnColors = []
    for(let i=0; i<cpitn.length; i++){
      this.cpitns.push(cpitn[i])
      this.cpitnColors.push((iroMap.get(cpitnIroKbn[i]) ? iroMap.get(cpitnIroKbn[i]) : 'transparent') as string)
    }
  }

  getShishikiColor(upperFlg: boolean, teethIndex: number, shishikiIndex: number):string{

    const tnum = ((upperFlg ? 0 : 16) + (teethIndex + 1)).toString()
    const snum = (shishikiIndex + 1).toString()

    const ret = this.shishikiInfo.get(tnum)?.get(snum)
    return ret ? this.iroMap.get(ret) as string : 'white'
  }

  getTeethColor(upperFlg: boolean, teethIndex: number): string{
    const tnum = ((upperFlg ? 0 : 16) + (teethIndex + 1)).toString()
    const ret = this.teethInfo.get(tnum)
    return ret ? this.iroMap.get(ret) as string : 'white'
  }

  getPHantei(index: number): string{
    return (this.pHanteis[index] ? this.pHanteis[index] : '')
  }

  getPHanteiColor(index: number): string{
    return this.pHanteiColors[index] ? this.pHanteiColors[index] : 'white'
  }

  getCpitn(index: number): string{
    return (this.cpitns[index] ? this.cpitns[index] : '')
  }

  getCpitnColor(index: number): string{
    return this.cpitnColors[index] ? this.cpitnColors[index] : 'white'
  }

  getColor(iroKbn: string): string{
    return iroKbn ? this.iroMap.get(iroKbn) as string : 'white'
  }

  getTokushuKenshinName(kbn: string): string{
    const n = TokushuKenshin.getName(kbn)
    return n ? n : '-'
  }

  getShisekiChinchakudoName(kbn: string): string{
    const n = ShisekiChinchakudo.getName(kbn)
    return n ? n : '-'
  }

  getSeisoJotaiName(kbn: string): string{
    const n = SeisoJotai.getName(kbn)
    return n ? n : '-'
  }
}